import { md5 } from '@noble/hashes/legacy.js';
import { sha256 } from '@noble/hashes/sha2.js';
import { bytesToHex } from '@noble/hashes/utils.js';

export type BrowserUploadIdentity = {
  contentHash: string;
  contentMd5: string;
  sizeBytes: number;
};

function base64(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary);
}

/**
 * SHA-256 (native WebCrypto in secure contexts) and MD5 of an upload body.
 * Runs inside the hash worker; the main-thread fallback is the same code.
 */
export async function digestBrowserUploadBody(
  body: Blob
): Promise<BrowserUploadIdentity> {
  const bytes = new Uint8Array(await body.arrayBuffer());
  const subtle = globalThis.crypto?.subtle;
  const shaBytes = subtle
    ? new Uint8Array(await subtle.digest('SHA-256', bytes))
    : sha256(bytes);
  return {
    contentHash: `sha256:${bytesToHex(shaBytes)}`,
    contentMd5: base64(md5(bytes)),
    sizeBytes: body.size,
  };
}
